import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Permissions } from '../permissions';

/**
 * Redirects to the correct dashboard based on the user's role.
 * SystemAdmin → /  (admin dashboard, no redirect)
 * All other roles → /dashboard/employee
 */
export const dashboardGuard: CanActivateFn = (_, state) => {
  const auth   = inject(AuthService);
  const router = inject(Router);

  const isAdmin = auth.hasPermission(Permissions.DASHBOARD_VIEW);

  if (!isAdmin && state.url === '/') {
    return router.createUrlTree(['/dashboard/employee']);
  }

  return true;
};
